import { Component } from '@angular/core';
import { UserService } from '../../user.service';
import { UniversalStorageService } from '../../../services/universal-storage.service';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent {
    user_name: string | null;
    user_email: string;
    checkbox1Checked = false;
    checkbox2Checked = false;
    checkbox3Checked = false;
    constructor(
        private userservice: UserService,
        private storageService: UniversalStorageService
    ) {
        this.user_name = this.storageService.getItem('loggedInUsername');
        const token = this.storageService.getItem('BEARER_TOKEN');
        // Replace with your token storage mechanism
        if (token) {
            const tokenPayload = this.decodeToken(token);
            this.user_email = tokenPayload.data.email;
        }
        this.listNotification(this.user_email);
    }
    private decodeToken(token: string) {
        const tokenParts = token.split('.');
        if (tokenParts.length !== 3) {
            throw new Error('Invalid token format');
        }

        const tokenPayload = JSON.parse(atob(tokenParts[1]));
        return tokenPayload;
    }

    onSubmit() {
        // Check the values of the checkbox properties
        if (this.checkbox1Checked) {
            this.checkbox1Checked = true;
        }

        if (this.checkbox2Checked) {
            this.checkbox2Checked = true;
            // Checkbox 2 is checked
            // Perform actions for checkbox 2
        }

        if (this.checkbox3Checked) {
            this.checkbox3Checked = true;
        }
        const checkbox = {
            promotions: this.checkbox1Checked,
            announcements: this.checkbox2Checked,
            send_emails: this.checkbox3Checked,
            user_email: this.user_email,
        };
        this.userservice.notification(checkbox).subscribe((response) => {
            console.log(response);
        });

        // Handle form submission logic
    }
    listNotification(email) {
        this.userservice.listNotification(email).subscribe(
            (response) => {
                this.checkbox1Checked =
                    response['active_notification'].promotions;
                this.checkbox2Checked =
                    response['active_notification'].announcements;
                this.checkbox3Checked =
                    response['active_notification'].send_email; // Log the entire response object
            },
            (error) => {
                console.error(error); // Log any errors that may occur
            }
        );
    }
}
